export const AVAILABLE_ZOOM = [
  { label: 'x1', value: 0.025 },
  { label: 'x2', value: 0.05 },
  { label: 'x3', value: 0.075 },
  { label: 'x5', value: 0.125 },
];
